module.exports = __webpack_public_path__ + "static/media/content.cb5c10ae.md";